import { DateTime } from "luxon";

/**
 * How many of the hour options MUI lists first belong at the end instead.
 *
 * MUI always lists hours 00 to 23 ascending and drops the disabled ones, so a night shift reads
 * "00 01 ... 06 18 ... 23" - the end of the shift before its start. The hours up to and including
 * the range's last hour are the ones that belong last; returning their count lets the caller push
 * that many items to the back with flex `order`.
 *
 * Returns null when the range sits inside one day, where the ascending list is already correct.
 */
export function hoursToMoveLast(minValue: DateTime, maxValue: DateTime): number | null {
  if (!minValue.isValid || !maxValue.isValid) return null;
  if (minValue.toISODate() === maxValue.toISODate()) return null;

  return maxValue.hour + 1;
}

/**
 * Flex `order` for the hours column, or undefined when the ascending list is already correct.
 * Kept apart from the component so the selector and the count can be asserted without MUI.
 */
export function clockHourOrderSx(minValue: DateTime, maxValue: DateTime) {
  const leadingHours = hoursToMoveLast(minValue, maxValue);
  if (leadingHours === null) return undefined;

  return {
    '& .MuiMultiSectionDigitalClockSection-root:first-of-type': {
      display: 'flex',
      flexDirection: 'column',
      '& > *': { flexShrink: 0 },
      [`& > *:nth-of-type(-n + ${leadingHours})`]: { order: 1 },
    },
  };
}
